import template from './userTemplateIcon.html';

export default {
  template,
  controllerAs: 'vm',
  bindings: {
    type: '<',
  },
};
